module.exports = __webpack_public_path__ + "img/tetle.b29d93c7.svg";